// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1LzHf","subheader":"ReorderModal_subheader__-M9OK","listWrap":"ReorderModal_listWrap__pHI5V"};